package com.sddamico.swigmore.ds.brand

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeCaps
import com.sddamico.swigmore.ds.typeDisplay
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** Crest + "Swigmore" + "FOOTBALL LEAGUE · COACHES POLL" lockup from the app header. */
@Composable
fun Wordmark(
  modifier: Modifier = Modifier,
  tagline: String = "Football League · Coaches Poll",
  onClick: (() -> Unit)? = null,
) {
  val handler = onClick
  Div(
    attrs = Modifier
      .css("display" to "flex", "align-items" to "center", "gap" to "12px")
      .then(if (onClick != null) Modifier.css("cursor" to "pointer") else Modifier)
      .then(modifier)
      .toAttrs { if (handler != null) onClick { handler() } }
  ) {
    Crest()
    Div {
      Div(attrs = Modifier.typeDisplay("19px").toAttrs()) { Text("Swigmore") }
      Div(attrs = Modifier.typeCaps("9px").css("color" to SwColor.gold, "margin-top" to "4px").toAttrs()) {
        Text(tagline)
      }
    }
  }
}
